import {useEffect, useState} from 'react'
import useHotjarExternal from 'react-use-hotjar'
import {useRouter} from 'next/router'

const userActions = ['mousemove', 'scroll', 'keydown', 'click', 'touchstart']

const useHotjar = (id: number, version: number, enableDebug = false): void => {
  const router = useRouter()
  const {initHotjar, stateChange} = useHotjarExternal()

  const [shouldInitialize, setShouldInitialize] = useState(false)

  const handleUserAction = () => {
    setShouldInitialize(true)
  }

  useEffect(() => {
    for (const action of userActions) {
      window.addEventListener(action, handleUserAction)
    }

    return () => {
      for (const action of userActions) {
        window.removeEventListener(action, handleUserAction)
      }
    }
  }, [])

  useEffect(() => {
    if (!shouldInitialize) {
      return
    }

    initHotjar(id, version, enableDebug)

    router.events.on('routeChangeComplete', stateChange)

    return () => {
      router.events.off('routeChangeComplete', stateChange)
    }
  }, [shouldInitialize, id, version, router, initHotjar])
}

export default useHotjar
